import StartPage from '../../components/pages/StartPage';
import themes from '../../themes';

export default function Startseite() {
  return <StartPage theme={themes.tragen} station={'tragen'} />;
}
